export const UNDEFINE = "";
export const SUBMIT_FAILED = "submitFailed";
export const SUBMITTED = "submitted";
export const EDITED_TRIP_RECORD = "editedTripRecord";
export const OPEN_TRIP_RECORD = "openTripRecord";
export const OPEN_HAIL_RECORD = "openHailRecord";
export const RECENT_SUBMITTED_TRIP = "recentSubmittedTripRecord";
export const UNSUBMITTED = "Unsubmitted";
export const SUBMISSION_ERROR = "Submission Error";
export const PREVIOUSLY_ACCEPTED = "Edited (Previously Accepted)";

export const tripStatusToDisplay = (status) => {
  switch (status) {
    case SUBMIT_FAILED:
    case SUBMISSION_ERROR:
      return "Submit Failed";
    case SUBMITTED:
      return "Submitted";
    case EDITED_TRIP_RECORD:
    case PREVIOUSLY_ACCEPTED:
      return "Edited Trip Record";
    case OPEN_TRIP_RECORD:
    case UNSUBMITTED:
    case UNDEFINE:
      return "Open Trip Record";
    case OPEN_HAIL_RECORD:
      return "Open Hail Record";
    case RECENT_SUBMITTED_TRIP:
      return "Submitted Trip Record";

    default:
      return "Unassigned";
  }
};

export const Sections = [
  {
    id: "open",
    title: "Unsubmitted Trip Reports",
    filter: [
      SUBMIT_FAILED,
      OPEN_TRIP_RECORD,
      OPEN_HAIL_RECORD,
      UNDEFINE,
      UNSUBMITTED,
      SUBMISSION_ERROR,
    ],
  },
  {
    id: "recent",
    title: "Recently Submitted Trip Reports",
    filter: [SUBMITTED, RECENT_SUBMITTED_TRIP],
  },
  {
    id: "edit",
    title: "Edited Submitted Trip Reports",
    filter: [EDITED_TRIP_RECORD, PREVIOUSLY_ACCEPTED],
  },
];

export const updateTripStatus = function (trip_status) {
  let newTripStatus = trip_status;

  switch (trip_status) {
    case EDITED_TRIP_RECORD:
    case SUBMITTED:
    case SUBMIT_FAILED:
      newTripStatus = OPEN_TRIP_RECORD;
      break;
    case OPEN_TRIP_RECORD:
      break;
    default:
      newTripStatus = UNDEFINE;
  }

  return newTripStatus;
};
